/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SourceInvoice/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import PaymentAccount from './PaymentAccount/index'
import React from 'react'
import TxPlan from './TxPlan/index'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import TysiaIconDescription from 'DesignSystem/Svgs/TysiaIconDescription/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function SourceInvoice({
  children,
  viewPath = "/App/Account/EmbeddableCoreMessageListener/PaymentsCreatePaymentPlanForExistingInvoice/Content/Content/SourceInvoice"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<div
  data-testid="SourceInvoice.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h5"
 text="Setup autopay on Source Invoice"
/>
<div
  data-testid="SourceInvoice.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-1-Z1H5BVb': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaIconDescription
  viewPath={`${viewPath}/TysiaIconDescription`}
/>
<div
  data-testid="SourceInvoice.Vertical:1"
  data-view-path={viewPath}
 style={{'--ml-2-Z1H5BVb': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Vertical1}`}
>
<PaymentAccount
  viewPath={`${viewPath}/PaymentAccount`}
/>
<TxPlan
  viewPath={`${viewPath}/TxPlan`}
/>
</div>
</div>
</div>
{children}
</React.Fragment>)
}